import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { AddressType, RsvpType } from "../types/types";
import { db } from "./firebaseConfig";

const addressesCollectionRef = collection(db, "addresses");

// Add an address
export const addAddress = async (address: AddressType) => {
  try {
    await addDoc(addressesCollectionRef, address);
    console.log("Address added successfully! \n", address);
  } catch (error) {
    console.error("Error adding address: ", error);
  }
};

const rsvpsCollectionRef = collection(db, "rsvps");

export const addRsvp = async (rsvp: RsvpType) => {
  try {
    await addDoc(rsvpsCollectionRef, rsvp);
    console.log("RSVP added successfully!", rsvp);
  } catch (error) {
    console.error("Error adding RSVP:", error);
  }
};

export const getRsvpByAddressKey = async (
  addressKey: string
): Promise<RsvpType | null> => {
  try {
    // Query for RSVP docs where "addressKey" equals the joined string
    const q = query(
      rsvpsCollectionRef,
      where("__addressKey", "==", addressKey)
    );
    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      // If there's a matching doc, return the first match as an RsvpType
      console.log("person has already RSVP'd", snapshot.docs[0].data());
      return snapshot.docs[0].data() as RsvpType;
    }
    return null;
  } catch (error) {
    console.error("Error fetching RSVP:", error);
    return null;
  }
};
